<template>
  <div>
    <Transition name="search">
      <div class="search-page" v-show="IsShow">
        <div class="search-content">
          <component
            :is="isModules"
            :tabId="tabId"
            :IsShow="IsShow"
            ref="search"
            @search="search"
            @cancel="cancel"
          ></component>
        </div></div
    ></Transition>
  </div>
</template>
<script>
import Search from "./index";
export default {
  props: {
    //tab页id
    tabId: {
      type: Number,
    },
    //组件模块
    modules: {
      type: String,
      default: "myGoods",
    },
    IsShow: {
      type: Boolean,
    },
  },
  watch: {
    tabId() {
      console.log("tab页改变", this.tabId);
    },
  },
  data() {
    return {
      goodsText: "",
      isModules: null,
    };
  },
  created() {
    this.isModules = Search[this.modules];
    console.log("组件", Search, this.modules, this.isModules);
  },
  methods: {
    search(params) {
      this.$emit("search", params);
    },
    cancel() {
      this.$emit("cancel");
    },
    focusSelectText() {},
    getSelectText() {},
    blurSelectText() {},
    searchGoods() {},
  },
};
</script>
<style lang="scss" scoped>
.search-page {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: white;
  z-index: 4;
}
.search-content {
  padding: 0.3rem;
}
/* //淡入淡出 */
.search-enter-active,
.search-leave-active {
  transition: opacity 0.1s;
}
.search-enter,
.search-leave-to {
  opacity: 0;
}
</style>
